// extracted by mini-css-extract-plugin
export default {"card":"HVBA1","icon":"QECTG","hover":"Bdqpt","content":"KW3o2","background-image":"umtmm","subtitle":"tH0RZ"};